/**
 * TrustGrid Evidence - Dual View Container
 * Allows switching between Simple Card View and D3.js Interactive Graph
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import { AppstoreOutlined, DeploymentUnitOutlined } from '@ant-design/icons';
import TrustGridPage from '../../../components/layout/TrustGridPage';
import ProjectSelector from './ProjectSelector';
import EvidenceSimple from './EvidenceSimple';
import EvidenceGraph from './EvidenceGraph';

const STORAGE_KEY = 'trustgrid_evidence_view';

function Evidence() {
  const location = useLocation();

  // Build breadcrumbs from navigation state or use defaults
  const breadcrumbs = useMemo(() => {
    const baseBreadcrumbs = location.state?.breadcrumbs || [
      { label: 'TrustGrid', path: '/trustgrid/dashboard' },
    ];
    return [...baseBreadcrumbs, { label: 'Evidence & Control Mapping', path: '/trustgrid/evidence' }];
  }, [location.state]);

  const [activeTab, setActiveTab] = useState(() => {
    // Load saved preference or default to 'simple'
    return localStorage.getItem(STORAGE_KEY) || 'simple';
  });

  useEffect(() => {
    // Save preference to localStorage whenever it changes
    localStorage.setItem(STORAGE_KEY, activeTab);
  }, [activeTab]);

  const tabItems = [
    {
      key: 'simple',
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <AppstoreOutlined />
          Simple View
        </span>
      ),
      children: <EvidenceSimple />,
    },
    {
      key: 'graph',
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <DeploymentUnitOutlined />
          Interactive Graph
        </span>
      ),
      children: <EvidenceGraph />,
    },
  ];

  return (
    <TrustGridPage
      title="Evidence & Control Mapping"
      subtitle="View controls and their linked evidence in card view or interactive graph"
      breadcrumbs={breadcrumbs}
    >
      <ProjectSelector />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
        type="card"
      />
    </TrustGridPage>
  );
}

export default Evidence;
